import {Component, OnDestroy} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterOutlet} from "@angular/router";
import {MatToolbarModule} from "@angular/material/toolbar";
import {LoadingService} from "projects/nter-ui-kit/src/lib/framework/util/service/loading.service";
import {MenuModuleComponent} from "src/app/pages/admin-panel/menu-module/menu-module.component";
import {MaterialModule} from "@ui-webkit/modules/material.module";
import {MatMenuModule} from "@angular/material/menu";
import {AuthenticationService} from "@ui-kit/security/service/authentication.service";
import {CustomIconService} from "@app/config/custom-icon.service";
import {Observable} from "rxjs";
import {BreadcrumbService} from "@ui-kit/utils/service/breadcrumb.service";
import {ProcessingDialogService} from "@ui-webkit/components/processing-dialog/processing-dialog.service";
import {SiteNavbarComponent} from "src/app/components/site-navbar/site-navbar.component";

@Component({
  selector: 'app-admin-panel',
  standalone: true,
  imports: [
    MaterialModule,
    CommonModule,
    MatToolbarModule,
    RouterOutlet,
    MenuModuleComponent,
    MatMenuModule,
    SiteNavbarComponent
  ],
  templateUrl: './admin-panel.component.html',
  styleUrls: ['./admin-panel.component.scss']
})
export class AdminPanelComponent implements OnDestroy {
  protected loading$ = this.loader.loading$;
  protected date: Date = new Date();
  protected breadcrumbs$: Observable<string>;

  constructor(private loader: LoadingService,
              private authenticationService: AuthenticationService,
              private iconService: CustomIconService,
              private breadcrumbService: BreadcrumbService,
              private processingDialogService: ProcessingDialogService
  ) {
    this.iconService.loadSvgIcons(['brand-logo', 'brand-icon-alt-1']);
    this.breadcrumbs$ = this.breadcrumbService.getBreadcrumbs();
  }

  protected logout(): void {
    this.processingDialogService.open();
    this.authenticationService.logout();
  }

  ngOnDestroy(): void {
    this.processingDialogService.close();
  }
}
